import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setLienFee } from '../../redux/modules/titlefees';
import Dropdown from '../../components/Dropdown';
import precise from '../../modules/precise';
import getPipeValue from '../../modules/getPipeValue';
import TextInput from '../../components/TextInput';

class Liens extends Component {
  constructor(props) {
    super(props);
    this.onValueSelect = this.onValueSelect.bind(this);
  }

  onValueSelect(event) {
    const value = event.target.value;
    const label = this.getOptions()[event.target.selectedIndex][0];
    this.props.setLienFee(precise(value), value, label);
  }

  // function LoadListLienVessel() {
  //     var LL = thisGetField("Liens")
  //     LL.prop('readonly', false);
  //     LL.clearItems();
  //     LL.setItems([
  //         ["No Lien to record", 0.00],
  //         ["Record 1 lien with Vessel Title Transfer", 1.00],
  //         ["Record 2 liens with Vessel Title Transfer", 2.00]
  //     ]);
  // }

  // function LoadListLien() {
  //     var LL = thisGetField("Liens")
  //     LL.prop('readonly', false);
  //     LL.clearItems();
  //     LL.setItems([
  //         ["No Lien to record", 0.00],
  //         ["Record 1 lien with Title Transfer", 2.00],
  //         ["Record 2 liens with Title Transfer", 4.00]
  //     ]);
  // }

  // function LoadListLienOnlyAdd() {
  //     var LLO = thisGetField("Liens")
  //     LLO.prop('readonly', false);
  //     LLO.clearItems();
  //     LLO.setItems([
  //         ["Lien included in Lien Add / Only", 0.00],
  //         ["2nd lien with Lien Add / Only ", 2.00]
  //     ]);
  // }

  // function LoadListLienVesselOnlyAdd() {
  //     var LLA = thisGetField("Liens");
  //     LLA.prop('readonly', false);;
  //     LLA.clearItems();
  //     LLA.setItems([
  //         ["Lien included: Vessel Lien Add / Only", 0.00],
  //         ["2nd lien with Vessel Lien Add / Only", 1.00]
  //     ]);
  // }

  getOptions() {
    const { selectedVehicleValue } = this.props;
    let r16 = 0;
    if (selectedVehicleValue) {
      r16 = Number(getPipeValue(selectedVehicleValue, 'r16'));
    }
    const { floridaTitle, mcoTitle, osTitle } = this.props.selectedTitleVariables;
    const t2 = Number(this.props.selectedTitleVariables.t2);
    const t3 = Number(this.props.selectedTitleVariables.t3);

    // Just for debugging. Remove after fully tested.
    // console.log('Liens, getOptions', { r16, t2, t3, floridaTitle, mcoTitle, osTitle });

    const loadListLienVessel = [
      ['No Lien to record', 0],
      ['Record 1 lien with Vessel Title Transfer', 1],
      ['Record 2 liens with Vessel Title Transfer', 2],
    ];

    const loadListLien = [
      ['No Lien to record', 0],
      ['Record 1 lien with Title Transfer', 2],
      ['Record 2 liens with Title Transfer', 4],
    ];

    const disableLien = [
      ['No Lien to record', 0],
    ];

    const loadListLienOnlyAdd = [
      ['Lien included in Lien Add / Only', 0],
      ['2nd lien with Lien Add / Only ', 2],
    ];

    const loadListLienVesselOnlyAdd = [
      ['Lien included: Vessel Lien Add / Only', 0],
      ['2nd lien with Vessel Lien Add / Only', 1],
    ];

    let dropdown = disableLien;

    // Note: we have to sortof 'cascade' down the list of
    // dropdowns because of how John formatted his PDF Code.

    // These are the options are they appear in the PDF
    // when you choose an option from `Florida Title`
    if (floridaTitle) {
      if (r16 === t2 || r16 === 0 || t2 === 8) {
        if (t2 === 5) {
          dropdown = loadListLienVessel;
        } else {
          dropdown = loadListLien;
        }

        if (t2 === 7) {
          dropdown = disableLien;
        }

        if (t3 === 1) {
          dropdown = loadListLienOnlyAdd;
        }

        if (t3 === 5) {
          dropdown = loadListLienVesselOnlyAdd;
        }
      }
    }

    // These are the options are they appear in the PDF
    // when you choose an option from `MCO Manufacturer`
    if (mcoTitle) {
      // TODO: Funcitonal tests may reveal that this default is too harsh.
      // This default did not exist in the PDF, but seems nessesary here
      // for certain vehicle types.
      dropdown = loadListLien;

      if (r16 === t2 || r16 === 0) {
        if (t2 === 5) {
          dropdown = loadListLienVessel;
        } else {
          dropdown = loadListLien;
        }
        if (t2 === 7) {
          dropdown = disableLien;
        }
      }
    }

    // These are the options are they appear in the PDF
    // when you choose an option from `Out of State Title`
    if (osTitle) {
      // TODO: Funcitonal tests may reveal that this default is too harsh.
      // This default did not exist in the PDF, but seems nessesary here
      // for certain vehicle types.
      dropdown = loadListLien;

      if (r16 === t2 || r16 === 0) {
        if (t2 === 5) {
          dropdown = loadListLienVessel;
        } else {
          dropdown = loadListLien;
        }
        if (t2 === 7) {
          dropdown = disableLien;
        }
      }
    }

    return dropdown;
  }

  render() {
    const { lienFeeSelectedValue, lienFee, lienFeeSelectedValueLabel } = this.props;
    return (
      <div className="Row Title-feeRow">

        <TextInput
          id="Tsub2"
          data-id="Liens Fee Total"
          tooltip="Plus $ Title Lien Fees"
          value={lienFee}
          readOnly
          className="Row-total"
          tabIndex="-1"
        />

        <Dropdown
          id="Liens"
          data-tooltip="Liens"
          options={this.getOptions()}
          onChange={this.onValueSelect}
          selectedValue={lienFeeSelectedValue}
          className="Dropdown Row-dropdown no-print"
        />

        <b className="print-label print-only">{lienFeeSelectedValueLabel}</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedVehicleValue: state.registration.selectedVehicleValue,
    selectedTitleVariables: state.titlefees.selectedTitleVariables,
    lienFee: state.titlefees.lienFee,
    lienFeeSelectedValue: state.titlefees.lienFeeSelectedValue,
    lienFeeSelectedValueLabel: state.titlefees.lienFeeSelectedValueLabel,
  };
};

export default connect(mapStateToProps, { setLienFee })(Liens);
